import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shuffle",
  "use": "icon-shuffle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-shuffle\" id=\"icon-shuffle\"><polyline points=\"16 3 21 3 21 8\" /><line x1=\"4\" y1=\"20\" x2=\"21\" y2=\"3\" /><polyline points=\"21 16 21 21 16 21\" /><line x1=\"15\" y1=\"15\" x2=\"21\" y2=\"21\" /><line x1=\"4\" y1=\"4\" x2=\"9\" y2=\"9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol